export default {
      id: "common__edit_lg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__edit_lg",
      toString: function () {
        return this.url;
      }
    }